import React, { useMemo } from 'react';
import JsonLD from './JsonLD';
import { withPrefix } from 'gatsby';
import { withLocale } from 'utils/hocs';
import { returnLocalisedPath } from 'utils/globals';

const JsonLdBreadcrumb = withLocale(({ links, locale }) => {
  const structuredData = useMemo<Record<string, any> | undefined>(() => {
    if (links)
      return {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: links.map((link, key) => ({
          '@type': 'ListItem',
          position: key + 1,
          name: link.label?.text,
          item: link.slug
            ? process.env.GATSBY_BASE_HOST +
              withPrefix(returnLocalisedPath(locale[0], link.slug.url))
            : undefined,
        })),
      };
    return undefined;
  }, [links]);

  return <JsonLD structuredData={structuredData} />;
});

export default JsonLdBreadcrumb;
